import { useCallback, useRef, useState } from 'react';

import useMount from '@picsart/rc/useMount';

import { UseCopyToClipboard } from 'hooks/types';
import copyTextToClipboard from 'utils/copyTextToClipboard';

const useCopyToClipboard: UseCopyToClipboard = () => {
  const copyTimeoutRef = useRef({ id: null });
  const [isCopied, setIsCopied] = useState(false);

  useMount(() => () => {
    if (copyTimeoutRef.current.id) {
      clearTimeout(copyTimeoutRef.current.id);
    }
  });

  const handleCopyToClipboard = useCallback(
    async text => {
      if (!isCopied) {
        await copyTextToClipboard(text);
        setIsCopied(true);
        copyTimeoutRef.current.id = setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    },
    [isCopied],
  );

  return [isCopied, handleCopyToClipboard];
};

export default useCopyToClipboard;
